module.exports = __webpack_public_path__ + "static/media/confia_site_branca.a6a7176a.png";